(function() {

	

	/* Объект для работы с заказом */
	var Checkout = function(){
		var step = 1;

		var cobject = {};

		var $dom, $prevBtn, $nextBtn = $();

		function stepHandler(data) {
			if(data){
			if (cobject.repsonseHandler) {
				Checkout.enableNext();
				cobject.repsonseHandler(data);
			} else {
				if (data.ok) {
					var href = window.location.href;
					href = href.replace(/\?.*$/,"");
					var str = '';
					while(str.length<16){
						str+=Math.round(Math.random()*10).toString();
					}
					window.location.assign(href+"?s="+str);
				} else if (data.error) {
					if (cobject.errorHandler) {
						Checkout.enableNext();
						cobject.errorHandler(data);
					}
				}
			}
			}else{
				Checkout.enableNext();
			}
		}

		function nextHandler() {
			var $this = $(this);
			if ((!$this.hasClass('btn-disabled'))&&(!$this.hasClass('load'))) {

				if (cobject.nextAction) {
					var params = cobject.nextAction();
					if (params) {
						$this.addClass('load');
						Checkout.disableNext();
						Checkout.getJSON(params, stepHandler);
					}
				} else {
					$this.addClass('load');
					Checkout.disableNext();
					go(true);
				}
			}
			return false;
		}

		function prevHandler() {
			var $this = $(this);
			if ((!$this.hasClass('btn-disabled'))&&(!$this.hasClass('load'))) {

				if (cobject.prevAction) {
					var params = cobject.prevAction();
					if (params) {
						$this.addClass('load');
						Checkout.disablePrev();
						Checkout.getJSON(params, stepHandler);
					}
				}else{
					$this.addClass('load');
					var pos = $this.offset();
					Checkout.disablePrev();
					go(false);
				}
			}
			return false;
		}

		function go(next) {
			Checkout.getJSON({
				_do : (next) ? 'order_next' : 'order_prev'
			},
				stepHandler
			);
		}

		return {
			init: function(iface){
				$nextBtn = $("#next-btn").click(nextHandler);
				$prevBtn = $("#prev-btn").click(prevHandler);

				switch (iface) {
					case 'basket' :
						cobject = Checkout.Basket();
					break;
					case 'personal' :
						cobject = Checkout.Personal();
					break;
					case 'check' :
						cobject = Checkout.Check();
					break;
				}
			},
			disableNext : function() {
				$nextBtn.addClass('btn-disabled');
				$nextBtn.attr("disabled","disabled");
			},
			enableNext : function() {
				$nextBtn.removeClass('btn-disabled');
				$nextBtn.removeAttr("disabled");
				// $nextBtn.removeClass('load');
			},

			disablePrev : function() {
				$prevBtn.addClass('btn-disabled');
				$prevBtn.attr("disabled","disabled");
			},
			enablePrev : function() {
				$prevBtn.removeClass('btn-disabled');
				$prevBtn.removeAttr("disabled");
			},
			hideNext : function() {
				$nextBtn.hide()
			},
			showNext : function() {
				$nextBtn.show()
			},
			hidePrev : function() {
				$prevBtn.hide()
			},
			showPrev : function() {
				$prevBtn.show()
			},
			renameNext: function(text){
				$nextBtn.text(text);
				$nextBtn.addClass('btn');
			},
			renamePrev: function(text){
				$prevBtn.text(text);
			},
			DOM: function(){
				return $dom
			},
			getJSON : function(data, handler) {
				/* Пробрасываем в глобальный объект вместо использования локального */
				var action = data._do;
				delete data._do;
				Order.getJSON(action, data, handler);

				/*if (Talon.SESS_ID)
					data['SESS_ID'] = Talon.SESS_ID;
					data["ch_code"] = hash;
					data["lpu_id"] = lpu_id;
					$.post("/oa/", data, handler, 'json');*/
			},
			showError: function(error){
			}
		}
	}();

	/**
	  * Класс для работы с корзиной
	  */
	Checkout.Basket = function(){

		/** @type {Object} параметры */
		var opt = {
			scrollDuration : 300,
			realyProdCountText : 'В наличии CNT шт.'
		};



		/** @type {Object} данные объекта */
		var o = {
			summ : 0,
			shipment : 0,
			discount : 0,
			free: 0,
			total : 0
		};

		o.$table = $("#basket-checkout");

		//Checkout.renameNext("Оформить заказ");
		//Checkout.hidePrev();

		if (o.$table.length) {
			initBasketTable();
		}

		function initBasketTable() {
			var rowsHash = {};
			var $table = o.$table;

			$table.on('clearbasket', function() {
				Checkout.getJSON({ '_do': 'clear_basket' },emptyBasket);
			});

			var $rows = $table.find('tbody tr'),
			$total = $table.find('.total');
			for (var i = 0; i < $rows.length; i++) {
				rowsHash[$rows.eq(i).data('product-id')] = i;
			}

			var $countInputs = $table.find('.count input')
				//.inputArrowCounter()
				//.removeAttr('readonly')
				.change(countChangeHandler);
			
			$table.find('.count .u').click(function(){
				var inp = $(this).parent().find('input');
				var val = inp.val();
				val++;
				inp.val(val);
				inp.trigger('change');
			});

			$table.find('.count .d').click(function(){
				var inp = $(this).parent().find('input');
				var val = inp.val();
				if(val == 1)
					return false;
				val--;
				inp.val(val);
				inp.trigger('change');
			});

			$table.find('.del').click(deleteHandler);
			var $discount = $('#place').find('.discount_block');
			$discount.find('.discount_input').click(discountHandler);
			$clearBtn = $("#clear-btn").click(clearHandler);

			function clearHandler() {
				if(window.confirm("Вы действительно хотите очистить корзину?")){
					$table.fadeOut().remove();
					Checkout.getJSON({ '_do': 'clear_basket' },emptyBasket);
				}
			}

			function countChangeHandler() {
				var val = this.value;

				if(isNaN(parseInt(val)) || parseInt(val) <= 0)
					val = 1;
				this.val = 1;

				var $row = $(this).parents('tr').eq(0),
					id = $row.data('product-id'),
					count = val;
				Order.update(id, count, updateHandler);
			}

			$table.on('change', '.measurement-type', measurementTypeChangeHandler);
			var $submitBtn = $('.default-btn.pop_up_btn');
			checkAllMeasurementTypesSelected();

			function measurementTypeChangeHandler(){
				var $row = $(this).parents('tr').eq(0),
					id = $row.data('product-id');
				Order.updateMeasurmentType(id, this.value);
				checkAllMeasurementTypesSelected();
			}

			function checkAllMeasurementTypesSelected(){
				var allSelected = true;
				$table.find('.measurement-type').each(function(){
					if(this.selectedIndex == 0)
						allSelected = false;
				});
				if(allSelected)
					$submitBtn.removeClass('disabled');
				else
					$submitBtn.addClass('disabled');
			}

			function discountHandler() {
				var code = $('input[name=discount_code]').val();
				if (code) {
					$discount.find('.discount_input').addClass('load');
					Checkout.getJSON({ '_do': 'discount_code', 'code': code }, answer);
				}
			}

			function answer(data) {
				o.summ = parseFloat(data.summ);
				o.discount = parseFloat(data.discount);
				if (o.discount > 0) {
					$discount.fadeOut(500, function(){
						$discount.html('<div class="discount_ok">Ваша скидка: '+o.discount+'%</div>');
						$discount.show();
					});
				}
				$discount.find('.discount_input').removeClass('load');

				$total.html(o.summ.toPrice());

				updateTotal();
			}


			function deleteHandler() {
				if(window.confirm("Вы действительно хотите убрать товар из корзины?")){
					var $row = $(this).parents('tr').eq(0),
						id = $row.data('product-id');
					Order.update(id, 0, updateHandler);
				}
			}

			function updateHandler(data) {
				var id = (data.item) ? data.item.id : data.deleted;
				if (id) {
					var $row = $rows.eq(rowsHash[id]);
					if (data.item) {
						$row.find(".count input").val(data.item.count);
						var $summ = $row.find('.summ');
						// $summ.html((data.item.price * data.item.count).toPrice());
					} else if (data.deleted) {
						$row.remove();
						if (data.count == 0) {
							emptyBasket();
						}
					}

				}

				$('#basket-table tbody tr').each(function(i){
					$(this).find('.field-l').html(i+1);
				});

				checkAllMeasurementTypesSelected();
				// o.summ = parseFloat(data.summ);
				// o.discount = parseFloat(data.discount);
				// $total.html(o.summ.toPrice());

				// updateTotal();
			}
		}

		function updateTotal() {
			if((o.free_summ>0)&&(o.summ>=o.free_summ)){
				o.shipment = 0;
			}
			o.total = o.summ + o.shipment - o.discount;
		}

		function emptyBasket() {
			window.location.reload();
		}

		return {
			/*
			nextAction : function() {
				//return prepareForm();
			},
			errorHandler: function(data){
				//Talon.OrderNew.showError(data.error_text);
			}*/
		}
	}


	

	Order.Checkout = Checkout;

})();